import { useState } from "react";

import { IconButton, Popover, Typography } from "@mui/material";
import { FaCircleQuestion } from "react-icons/fa6";

export type TExplanationPopoverProps = {
	text: string;
};

export function ExplanationPopover({ text }: TExplanationPopoverProps) {
	const [anchor, setAnchor] = useState<HTMLElement | null>(null);

	return (
		<>
			<IconButton
				className="icon-button"
				sx={{ padding: 0 }}
				onClick={(event) => {
					setAnchor(event.currentTarget);
				}}>
				<FaCircleQuestion />
			</IconButton>
			<Popover
				open={Boolean(anchor)}
				anchorEl={anchor}
				className="note-popover-container"
				anchorOrigin={{
					vertical: "top",
					horizontal: "left",
				}}
				onClose={() => {
					setAnchor(null);
				}}>
				<div className="note-popover-content-container">
					<Typography className="normal-text">{text}</Typography>
				</div>
			</Popover>
		</>
	);
}
